import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Grid, Typography } from "@mui/material";
import {
  FinancingCard,
  FinancingDetailsSection,
  getFinancingHeadingSx,
} from "../FinancingPresentation";
import { StyledTableRow } from "../../../shared/Tables/TableRow";
import { useTranslation } from "react-i18next";

const LeaseTable = ({ leasePaymentData, isLincolnBrand = false }) => {
  const { t } = useTranslation();
  const [accordion1Expanded, setAccordion1Expanded] = useState(false);
  const [accordion1Data, setAccordion1Data] = useState({});
  const [strippedData, setStrippedData] = useState({});

  const stripLeasePaymentData = (data) => {
    if (!data || typeof data !== "object") {
      return null;
    }

    const {
      capitalizedCostReduction,
      // eslint-disable-next-line no-unused-vars
      taxesAndFees,
      // eslint-disable-next-line no-unused-vars
      tradeInPrice,
      ...strippedData
    } = data;

    setAccordion1Data({
      capitalizedCostReduction,
      monthlyPayment: strippedData["monthlyPayment"],
      downPayment: strippedData["downPayment"],
      taxesAndFees: data["taxesAndFees"],
    });

    return strippedData;
  };

  useEffect(() => {
    const strippedData = stripLeasePaymentData(leasePaymentData);
    setStrippedData(strippedData);
  }, [leasePaymentData]);

  return (
    <>
      <Box
        gridColumn={{
          xs: "span 12",
        }}
      >
        <Grid container>
          <Grid item>
            <Typography
              variant="h3"
              sx={getFinancingHeadingSx(isLincolnBrand)}
              data-testid="payment-type-heading"
            >
              Lease
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box
        gridColumn={{
          xs: "span 12",
        }}
      >
        <FinancingCard data={strippedData} isLincolnBrand={isLincolnBrand} />
      </Box>
      <Box gridColumn={{ xs: "span 12" }}>
        <FinancingDetailsSection
          isLincolnBrand={isLincolnBrand}
          expanded={accordion1Expanded}
          onChange={() => setAccordion1Expanded(!accordion1Expanded)}
          heading={t("financing.lease.accordionHeaders.0")}
        >
          <StyledTableRow
            text={t("PurchaseDetails.paymentMethod.firstPayment")}
            data={accordion1Data["monthlyPayment"]?.content
              .replaceAll("per mo", "")
              .trim()}
          />

          <StyledTableRow
            text={t("PurchaseDetails.paymentMethod.downPayment")}
            indent
            data={accordion1Data["downPayment"]?.content}
          />

          <StyledTableRow
            text={t("PurchaseDetails.paymentMethod.taxesAndFees")}
            indent
            data={accordion1Data["taxesAndFees"]?.content}
          />
        </FinancingDetailsSection>
      </Box>
    </>
  );
};

LeaseTable.propTypes = {
  isLincolnBrand: PropTypes.bool,
  leasePaymentData: PropTypes.objectOf(
    PropTypes.shape({
      heading: PropTypes.string,
      content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
      ]),
    })
  ).isRequired,
};

export default LeaseTable;
